import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UiButton, UiIcon, UiTextField } from 'ui-components';
import { useDispatch } from 'react-redux';
import { addTicketRequest, changeProfileMenuStep } from 'store';
import { toast } from 'lib';

const MobileSizeSupportOpinion = ({ close }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  /**
   * ارسال فیدبک
   */
  const handleSubmit = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('title', 'bug');
    formData.append('description', description);
    formData.append('category_id', 1);
    try {
      await dispatch(addTicketRequest({ formData: formData })).unwrap();
      setDescription('');
      dispatch(changeProfileMenuStep('step_6'));
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast({
        title: t('support:error.addTicket.title'),
        description: t('support:error.addTicket.description'),
        type: 'error',
      });
    }
  };

  return (
    <>
      <div className='modal-header step-header'>
        <div className='header-info'>
          <UiIcon
            className='mr-0'
            icon='ri-arrow-right-s-line'
            size={20}
            color='#454545'
            onClick={() => dispatch(changeProfileMenuStep('step_4'))}
          />
          <span className='label'>{t('support:pageTitle')}</span>
        </div>
        <UiIcon
          className='header-close'
          icon='ri-close-circle-fill'
          size={20}
          color='#9CAEBB'
          onClick={close}
        />
      </div>

      <div className='modal-body'>
        <div className='body-support mt-8'>
          <div>{t('support:explainDetailsOfYourProblem')}</div>
          <div className='mt-16'>{t('common:description')}</div>
          <div className='button--wrapper flex col'>
            <UiTextField
              className='mb-16 textbox'
              rows={3}
              multiline
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <UiButton
              variant='contained'
              color='primary'
              fullWidth
              onClick={handleSubmit}
              disabled={loading || !description}
              loading={loading}
            >
              {t('support:send')}
            </UiButton>
          </div>
        </div>
      </div>
    </>
  );
};

MobileSizeSupportOpinion.propTypes = {
  close: PropTypes.func,
};

export default MobileSizeSupportOpinion;
